/* eslint no-shadow: ["error", { "allow": ["state", "getters"] }] */

import findIndex from 'lodash/findIndex'
import keyBy from 'lodash/keyBy'
import reject from 'lodash/reject'
import Vue from 'vue'

import { FETCH_COUNTRIES } from '../../actions.type'
import {
  CREATE_COUNTRY,
  REMOVE_COUNTRY,
  SET_COUNTRY_ALL_REQUEST,
  SET_COUNTRY_ALL_VALUE,
  UPDATE_COUNTRY
} from '../../mutations.type'

const state = {
  all: {
    request: {
      isLoading: undefined,
      isSuccess: undefined,
      isError: undefined,
      isFatalError: undefined,
      delay: undefined,
      lastRequestTime: undefined
    },
    value: []
  }
}

const getters = {
  countryAllValue: (state) => state.all.value,
  countryAllRequest: (state) => state.all.request,
  countryAllById: (state) => keyBy(state.all.value, 'id')
}

const actions = {
  async [FETCH_COUNTRIES]({ commit, state }, params) {
    if (
      (state.all.request.isSuccess && !params?.isReload) ||
      state.all.request.isLoading ||
      state.all.request.isError
    ) {
      return
    }
    try {
      const { data } = await Vue.axios.get('country', {
        'axios-retry': {
          beforeTry: () => {
            commit(SET_COUNTRY_ALL_REQUEST, {
              isLoading: true,
              isError: false
            })
          },
          afterTry: ({ delay, lastRequestTime }) => {
            commit(SET_COUNTRY_ALL_REQUEST, {
              isLoading: false,
              isError: true,
              delay,
              lastRequestTime
            })
          }
        }
      })
      commit(SET_COUNTRY_ALL_REQUEST, {
        isLoading: false,
        isSuccess: true
      })
      commit(SET_COUNTRY_ALL_VALUE, data)
    } catch (e) {
      commit(SET_COUNTRY_ALL_REQUEST, {
        isFatalError: true,
        isLoading: false
      })
    }
  },

  async SOCKET_CREATE_COUNTRY({ commit }, value) {
    commit(CREATE_COUNTRY, value)
  },

  async SOCKET_UPDATE_COUNTRY({ commit }, value) {
    commit(UPDATE_COUNTRY, value)
  },

  async SOCKET_REMOVE_COUNTRY({ commit }, id) {
    commit(REMOVE_COUNTRY, id)
  }
}

const mutations = {
  [SET_COUNTRY_ALL_REQUEST](state, request) {
    state.all.request = {
      ...state.all.request,
      ...request
    }
  },
  [SET_COUNTRY_ALL_VALUE](state, countries) {
    state.all.value = countries
  },
  [UPDATE_COUNTRY](state, updatedCountry) {
    state.all.value.splice(
      findIndex(state.all.value, { id: updatedCountry.id }),
      1,
      updatedCountry
    )
  },
  [CREATE_COUNTRY](state, createdCountry) {
    state.all.value.push(createdCountry)
  },
  [REMOVE_COUNTRY](state, id) {
    state.all.value = reject(state.all.value, { id })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
